<template>
	<div class="event-accept overFlowXauto">
		<div class="left-tree">
			<Tree @changeSwitch="changeSwitch" :switchVal="switchVal" @nodeClick="nodeClick"></Tree>
		</div>
		<div class="right-content">
			<div class="right-content-top" style="width:calc(100vw - 560px)">
				<div id="bar" style="width: 50%;height: 300px;"></div>
				<div id="pie" style="width: 50%;height: 300px;"></div>
			</div>
			<div class="right-content-bottom" style="width:calc(100vw - 560px)">
				<el-table :data="tableData" style="width:100%">
					<el-table-column prop="name" label="区域">
					</el-table-column>
					<el-table-column label="分类报警">
						<el-table-column prop="normal" label="普通报警">
						</el-table-column>
						<el-table-column prop="oneKey" label="一键报警">
						</el-table-column>
						<el-table-column prop="securitys" label="110报警">
						</el-table-column>
						<el-table-column prop="fire" label="120报警">
						</el-table-column>
						<el-table-column prop="firstAid" label="119报警">
						</el-table-column>
						<el-table-column prop="graphic" label="图文报警">
						</el-table-column>
						<el-table-column prop="helps" label="求助报警">
						</el-table-column>
					</el-table-column>
					<el-table-column label="报警处理">
						<el-table-column prop="wait" label="待处理">
						</el-table-column>
						<el-table-column prop="dealing" label="处理中">
						</el-table-column>
						<el-table-column prop="complete" label="已完成">
						</el-table-column>
						<el-table-column v-if="switchVal" prop="reportDown" label="已上报">
						</el-table-column>
						<el-table-column v-else prop="report" label="已上报">
						</el-table-column>
					</el-table-column>
				</el-table>
				<el-pagination :style="{textAlign:'right'}" :small="false" @size-change="pagination.sizeChange" @current-change="pagination.pageChange"
				 :current-page="pagination.page || 1" :page-sizes="pagination.pageSizes || [5]" :page-size="pagination.size || 5"
				 layout="total, sizes, prev, pager, next, jumper" :total="pagination.total || 0">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts';
	import Tree from '../../../../components/Tree/nodeTree';
	import {
		xlSasApi
	} from '../../../../api-path/xl-api.js'
	export default {
		components: {
			Tree
		},
		data() {
			return {
				switchVal: false,
				searchParams: {
					isDown: false,
					areaId: '',
					page: 1,
					size: 5,
				},
				pagination: {
					total: 0,
					page: 1,
					size: 5,
					sizeChange: this.sizeChange,
					pageChange: this.pageChange,
				}, // 分页
				tableData: [],
				searchParams2: {
					isDown: false,
					areaId: '',
				},
			}
		},
		methods: {
			changeSwitch(e) {
				this.switchVal = e;
				this.searchParams.isDown = e;
				this.searchParams2.isDown = e;
        if (this.searchParams.areaId === '' || this.searchParams2.areaId === '' || this.searchParams.areaId === null || this.searchParams2.areaId === null) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams();
				this.setSearchParams2()
			},
			nodeClick(node) {
				this.searchParams.areaId = node.id;
				this.searchParams2.areaId = node.id;
        if (this.searchParams.areaId === '' || this.searchParams2.areaId === '' || this.searchParams.areaId === null || this.searchParams2.areaId === null) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams();
				this.setSearchParams2()
			},
			// 每页显示条数
			sizeChange(size) {
				this.searchParams.size = this.pagination.size = size;
        if (this.searchParams.areaId === ''  || this.searchParams.areaId === null) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams()
			},
			// 当前页
			pageChange(page) {
				this.searchParams.page = this.pagination.page = page;
        if (this.searchParams.areaId === '' ||  this.searchParams.areaId === null ) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams()
			},
			setSearchParams() {
				//查询列表
				this.$http.get(xlSasApi.findAllByAreaId, {
					params: this.searchParams
				}).then(res => {
					if (res.status == 200) {
						this.tableData = res.result.pageList;
						this.pagination.total = res.result.total;
					}
				})
			},
			setSearchParams2() {
				//查询图表数据
				this.$http.get(xlSasApi.queryAlarmCount, {
					params: this.searchParams2
				}).then(res => {
					if (res.status == 200) {
						let data = res.result;
						let barXAxisData = [data.oneKey,data.graphic,
							data.helps,data.normal, data.securitys,data.fire, data.firstAid, 
						];
						// let barXAxis = ['普通报警', '一键报警', '110报警', '120报警', '119报警', '图文报警', '求助报警']
						let barXAxis = [ '一键报警','图文报警', '求助报警','普通报警', '110报警', '120报警', '119报警']
						let pieXAxisData = [{
								name: '待处理',
								value: data.wait
							},
							{
								name: '处理中',
								value: data.dealing
							},
							{
								name: '已完成',
								value: data.complete
							},
							{
								name: '已上报',
								value: this.switchVal ? data.reportDown : data.report
							},
							{
								name: '已超时',
								value: data.timeOut
							},
						]

						this.chartLine(barXAxisData, barXAxis)
						this.chartPie(pieXAxisData)
					}
				})
			},
			//绘制折线图
			chartLine(barXAxisData, barXAxis) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById('bar'))
				// 绘制图表
				myChart.setOption({
					color: ['#FF3333', '#66ccff', '#ffbf00', '#2fc25b','#0033FF', '#00cccc','#ff6600'],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '4%',
						right: '4%',
						bottom: '5%',
						top: '5%',
						containLabel: true
					},
					yAxis: {
						type: 'value',
						axisLabel:{
							color:'#999' 
						},
						axisLine: {
							show: false,
						},
						axisTick: {
							show: false
						},
						splitLine:{
							show: true,
							lineStyle:{
								color:'#ccc',
								type:'dashed'
							}
						},
						boundaryGap: [0, 0.01]
					},
					xAxis: {
						type: 'category',
						axisLabel:{
							color:'#999' 
						},
						axisLine: {
							show: false,
						},
						axisTick: {
							show: false
						},
						 
						data: barXAxis
					},
					series: [{
						name: '',
						type: 'bar',
						label: {
							show: true,
							position: 'top',
						},
						itemStyle: {
							normal: {
								color: function(params) {
									var colorList = ['#6cb8d8', '#434abf', '#ff9338', '#fe6a7a', '#ffc621'];
									return colorList[params.dataIndex]
								},
							}
						},
						barWidth: '50%',
						data: barXAxisData
					}],
				})
			},
			//绘制饼图
			chartPie(pieXAxisData) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById('pie'))
				// 绘制图表
				myChart.setOption({
					title:{
						show:true,
						text:'报警受理',
						textStyle:{
							color:'#999'
						}
					},
					legend: {
						type: 'plain',
						orient: 'horizontal',
						right: 'center',
						bottom: 0,
						data: ['待处理', '处理中', '已完成', '已上报', '已超时'],
					},
					series: [{
						color: ['#6cb8d8', '#434abf', '#ff9338', '#fe6a7a', '#ffc621'],
						name: '区域用户类型',
						type: 'pie',
						radius: [0, 100],
						center: ['50%', '50%'],
						roseType: 'radius',
						itemStyle:{ 
							normal:{ 
							   label:{ 
									position:'inside',
									show: true, 
									fontWeight:"bold",
									fontSize:16,
									formatter: '{c}' 
								}, 
								labelLine :{show:true} 
							} 
						},
						data: pieXAxisData
					}]
				})

			},

		}
	}
</script>

<style lang="less" scoped>
	.event-accept {
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		width: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;

		.left-tree {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;
		}

		.right-content {
			flex: 1;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.right-content-top {
				display: flex;
				width: 100%;
				justify-content: space-around;
				padding: 40px 0;
				box-sizing: border-box;
				border-bottom: 10px solid #f1f4fb;
				margin-bottom: 40px;
			}

			.right-content-bottom {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
		}
	}
</style>
